import { Link } from "gatsby"

import { FastlyImage } from "@components/FastlyImage"

const PageSectionCustomers = (props) => {
  const CustomerImage = (customer) => {
    let html
    if (customer.caseStudy) {
      html = (
        <span className="card casestudy">
          <Link to={customer.caseStudy.url}>
            <article className="card__article">
              <FastlyImage alt={customer.name} src={customer.logo.file.url} params="?height=55&width=224&fit=bounds" />
            </article>
          </Link>
        </span>
      )
    } else {
      html = (
        <span className="card customer">
          <FastlyImage alt={customer.name} src={customer.logo.file.url} params="?height=55&width=224&fit=bounds" />
        </span>
      )
    }
    return html
  }

  return (
    <section className="casestudies">
      <div className="casestudies__content">
        <h3 className="casestudies__title">Case Studies</h3>
        <div className="cards">{props.content.customers.map((customer) => CustomerImage(customer))}</div>
      </div>
    </section>
  )
}

export default PageSectionCustomers
